import type {
  ProviderDirectoryV2ContactPoint,
  ProviderDirectoryV2ContactPointPurpose,
  ProviderDirectoryV2ContactPointType,
  ProviderDirectoryV2SourceMode,
  ProviderDirectoryV2SourceType,
} from '@/services/types/provider-directory-v2-types';

import { baseApiClient as api } from '../baseService';

export const addTagTypes = ['provider-directory-v2'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      providerDirectoryV2ContactPointsCreate: build.mutation<
        ProviderDirectoryV2ContactPoint,
        ProviderDirectoryV2ContactPointsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-directory/v2/contact-points/`,
          method: 'POST',
          body: queryArg.providerDirectoryV2ContactPointCreateRequest,
        }),
        invalidatesTags: ['provider-directory-v2'],
      }),
      providerDirectoryV2ContactPointsPartialUpdate: build.mutation<
        ProviderDirectoryV2ContactPoint,
        ProviderDirectoryV2ContactPointsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-directory/v2/contact-points/${queryArg.contactPointId}/`,
          method: 'PATCH',
          body: queryArg.patchedProviderDirectoryV2ContactPointPatchRequest,
        }),
        invalidatesTags: ['provider-directory-v2'],
      }),
      providerDirectoryV2ContactPointsArchiveCreate: build.mutation<
        ProviderDirectoryV2ContactPoint,
        ProviderDirectoryV2ContactPointsArchiveCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-directory/v2/contact-points/${queryArg.contactPointId}/archive/`,
          method: 'POST',
        }),
        invalidatesTags: ['provider-directory-v2'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };

export type ProviderDirectoryV2ContactPointsCreateApiArg = {
  providerDirectoryV2ContactPointCreateRequest: ProviderDirectoryV2ContactPointCreateRequest;
};

export type ProviderDirectoryV2ContactPointsPartialUpdateApiArg = {
  contactPointId: string;
  patchedProviderDirectoryV2ContactPointPatchRequest: ProviderDirectoryV2ContactPointPatchRequest;
};

export type ProviderDirectoryV2ContactPointsArchiveCreateApiArg = {
  contactPointId: string;
};

export type ProviderDirectoryV2ContactPointCreateRequest = {
  owner_type: 'organization' | 'location' | 'service';
  owner_id: string;
  point_type: ProviderDirectoryV2ContactPointType | string;
  purpose?: ProviderDirectoryV2ContactPointPurpose | string;
  name?: string | null;
  is_preferred?: boolean;
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  formatted_address?: string | null;
  google_place_id?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  source_mode?: ProviderDirectoryV2SourceMode;
  source_type?: ProviderDirectoryV2SourceType;
  source_ref?: string | null;
  note?: string | null;
};

export type ProviderDirectoryV2ContactPointPatchRequest = {
  name?: string | null;
  is_preferred?: boolean | null;
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  formatted_address?: string | null;
  google_place_id?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  source_mode?: ProviderDirectoryV2SourceMode;
  source_type?: ProviderDirectoryV2SourceType;
  source_ref?: string | null;
  note?: string | null;
};

export const {
  useProviderDirectoryV2ContactPointsCreateMutation,
  useProviderDirectoryV2ContactPointsPartialUpdateMutation,
  useProviderDirectoryV2ContactPointsArchiveCreateMutation,
} = injectedRtkApi;
